import React, { useEffect, useState } from 'react';
import { Modal, Button, Space } from 'antd';
import './ViewSolicitacaoModal.css';
import { useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import { handleApiResponse, handleApiError } from '../../../utils/apiMessages';
import API_CONFIG from '../../../config/api.config';


function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
}

const ViewSolicitacaoModal = ({ isVisible, onClose, solicitacao }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleEdit = () => {
    onClose();
    navigate('/prefeitura/editar-solicitacao', {
      state: { idSolicitacao: solicitacao.SOL_ID }
    });
  };

  const handleCancel = () => {
    Modal.confirm({
      title: 'Confirmação',
      content: 'Você está cancelando uma solicitação, tem certeza que deseja continuar?',
      okText: 'Sim',
      cancelText: 'Não',
      width: 320,
      onOk: async () => {
        try {
          const payload = {
            SOL_PRE_ID: Number(solicitacao.SOL_PRE_ID),
            SOL_USU_ID: Number(solicitacao.SOL_USU_ID),
            SOL_VEI_ID: Number(solicitacao.SOL_VEI_ID),
            SOL_NOME_ITEM: solicitacao.SOL_NOME_ITEM,
            SOL_DESCRICAO: solicitacao.SOL_DESCRICAO,
            SOL_STATUS: 'CANCELADA'
          };

          const response = await api.put(API_CONFIG.ENDPOINTS.SOLICITACOES.ATUALIZAR(solicitacao.SOL_ID), payload);

          if (handleApiResponse(response.request, response.data, 'Solicitação cancelada com sucesso!')) {
            onClose();
            window.location.reload();
          }
        } catch (error) {
          handleApiError(error);
        }
      },
      okButtonProps: {
        danger: true
      }
    });
  };

  const handleSave = () => {
   // console.log('Salvando solicitação:', solicitacao?.SOL_ID);
  };

  const renderFooter = () => {
    if (solicitacao?.SOL_STATUS === "ABERTA") {
      return (
        <div className="modal-buttons-pre">
          <Button danger onClick={handleCancel}
            style={{
              background: '#fff',
              color: '#d32f2f',
              border: '1.5px solid #d32f2f',
              height: 48,
              fontSize: '1.15rem',
              minWidth: 160
            }}
            >
              Cancelar
          </Button>
          <Button type="primary" onClick={handleEdit}
            style={{
              background: 'linear-gradient(90deg, #001f4d 60%, #003380 100%)',
              color: '#fff',
              border: 'none',
              height: 48,
              fontSize: '1.15rem',
              minWidth: 160
            }}>Editar</Button>
        </div>
      );
    }
    return null;
  };

  return (
    <Modal
      title={`Solicitação #${solicitacao?.SOL_ID}`}
      open={isVisible}
      onCancel={onClose}
      //width={isMobile ? 320 : 800} // <-- aqui
      centered
      footer={renderFooter()}
      destroyOnClose={true}
      maskClosable={true}
      afterClose={() => {
        onClose();
      }}
      getContainer={false}
      style={{ position: 'relative' }}
      wrapClassName={isMobile ? "modal-mobile-fullscreen" : ""}
    >
      <div className="solicitacao-info">
        <p><strong>Veículo:</strong> {solicitacao?.VEI_DESCRICAO} ({solicitacao?.VEI_PLACA})</p>
        {/* <p><strong>Quantidade:</strong> {solicitacao?.SOL_NOME_ITEM}</p> */}
        <p><strong>Status:</strong> {solicitacao?.SOL_STATUS}</p>
        <p><strong>Data de Abertura:</strong> {new Date(solicitacao?.SOL_DATA_VINCULACAO).toLocaleDateString('pt-BR')}</p>
        <p><strong>Tipo de Veículo:</strong> {solicitacao?.VEI_TIPO}</p>
        {/*}  <strong>Descrição:</strong>
          <span className="descricao-texto">{solicitacao?.SOL_DESCRICAO}</span>*/}

      </div>
    </Modal>
  );
};

export default ViewSolicitacaoModal; 